export const formInfo = {
  fieldList: [
    {
      label: '开始时间',
      value: 'start_time',
      dateType: 'date',
      required: true,
      type: 'date',
      event: 'startTimeChange',
    },
    {
      label: '结束时间',
      value: 'end_time',
      dateType: 'date',
      required: true,
      type: 'date',
      event: 'endTimeChange',
    },
    {
      label: '统计周期',
      value: 'time_type',
      type: 'select',
      list: 'cycle',
    },
    {
      label: '产线',
      list: 'proline',
      type: 'select',
      value: 'production_line_id',
    },
    {
      label: '供应商',
      type: 'select',
      value: 'outsourcer',
      list: 'opr',
    },
    {
      type: 'slot',
      value: 'submit',
    },
  ],
  data: {
    start_time: (function () {
      const date = new Date();
      date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
      return date;
    }()),
    end_time: new Date(),
    time_type: '天',
    production_line_id: 0,
    outsourcer: 0,
  },
  listTypeInfo: {
    cycle: [
      {
        key: '天',
        value: '天',
      },
      {
        key: '自然周',
        value: '周',
      },
      {
        key: '汇报周',
        value: '汇报周',
      },
      {
        key: '自然月',
        value: '月',
      },
      {
        key: '结算月',
        value: '结算月',
      },
    ],
    proline: [ // 产线
      {
        key: '全部',
        value: 0,
      },
    ],
    opr: [ // 供应商
      {
        key: '全部',
        value: 0,
      },
    ],
  },
};
// 供应商排名表column
export const tableTopDataColumn = [
  {
    prop: 'rank',
    label: '排名',
    width: 50,
  },
  {
    prop: 'outsourcer',
    label: '供应商',
    width: 70,
  },
  {
    prop: 'production_line',
    label: '产线',
    showOverflowTooltip: true,
  },
  {
    prop: 'operator',
    label: '作业员',
    showOverflowTooltip: true,
  },
  {
    prop: 'real_hs',
    label: '实际总耗时',
    sortable: 'custom',
    width: 120,
  },
  {
    prop: 'status',
    label: '人员达标情况',
    width: 110,
  },
];
export const notQuaField = [
  {
    label: '异常原因来源',
    value: 'origin',
    type: 'select',
    list: 'origin',
    event: 'origin',
  },
  {
    label: '异常原因合理性',
    value: 'rationality',
    type: 'select',
    list: 'rationality',
    event: 'rationality',
  },
];
// 人员未达标情况分布 筛选值
export const notQuaFieldData = {
  origin: 0,
  rationality: 0,
};
export const tableTopData = {
  data: [],
  pageSize: 10,
  pageNo: 1,
  sortOrder: 'desc',
};
export const notQuaFieldList = {
  origin: [
    {
      key: '全部',
      value: 0,
    },
    {
      key: '外包商',
      value: 1,
    },
    {
      key: '内部',
      value: 2,
    },
  ],
  rationality: [
    {
      key: '全部',
      value: 0,
    },
    {
      key: '合理',
      value: 1,
    },
    {
      key: '不合理',
      value: 2,
    },
  ],
};
export const OverallTrendConfig = { // 整体达标趋势折线图设置
  option: {},
  load: false,
  clear: false,
};
export const workHourQualified = {
  option: {},
  load: false,
  clear: false,
};

export const supQualified = {
  option: {},
  load: false,
  clear: false,
};
export const proLQualified = {
  option: {},
  load: false,
  clear: false,
};
// 人员未达标情况
export const notquaConfig = {
  option: {},
  load: false,
  clear: false,
};

/** ***
 *人员有效工时详情页
 */

// 折线图
export const detailChartConfig = {
  option: {},
  load: false,
  clear: false,
};

export const detailFormInfo = {
  fieldList: [
    {
      label: '开始时间',
      value: 'start_time',
      dateType: 'date',
      required: true,
      type: 'date',
      event: 'startTimeChange',
    },
    {
      label: '结束时间',
      value: 'end_time',
      dateType: 'date',
      required: true,
      type: 'date',
      event: 'endTimeChange',
    },
    {
      label: '统计周期',
      value: 'time_type',
      type: 'select',
      list: 'cycle',
      event: 'time_type',
    },
    {
      label: '产线',
      list: 'proline',
      type: 'select',
      value: 'production_line_id',
      event: 'production_line_id',
    },
    {
      label: '供应商',
      type: 'select',
      value: 'outsourcer',
      list: 'opr',
      event: 'outsourcer',
    },
    {
      label: '作业员',
      type: 'select',
      value: 'operator',
      list: 'operator',
      event: 'operator',
      filterable: true,
    },
    {
      type: 'slot',
      value: 'submit',
    },
  ],
  data: {
    start_time: (function () {
      const date = new Date();
      date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
      return date;
    }()),
    end_time: new Date(),
    time_type: '天',
    production_line_id: 0,
    outsourcer: 0,
    operator: 0,
  },
  listTypeInfo: {
    cycle: [
      {
        key: '天',
        value: '天',
      },
      {
        key: '自然周',
        value: '周',
      },
      {
        key: '汇报周',
        value: '汇报周',
      },
      {
        key: '自然月',
        value: '月',
      },
      {
        key: '结算月',
        value: '结算月',
      },
    ],
    proline: [ // 产线
      {
        key: '全部',
        value: 0,
      },
    ],
    opr: [ // 供应商
      {
        key: '全部',
        value: 0,
      },
    ],
    operator: [ // 作业员
      {
        key: '全部',
        value: 0,
      },
    ],
  },
};

export const tableOverview = {
  column: [
    {
      prop: 'time',
      label: '日期',
    },
    {
      prop: 'name',
      label: '姓名',
    },
    {
      prop: 'outsourcer',
      label: '供应商',
    },
    {
      prop: 'production_line',
      label: '产线',
    },
    {
      prop: 'zy_hs',
      label: '中业总耗时',
      width: 150,
    },
    {
      prop: 'ny_hs',
      label: '内业总耗时',
      width: 150,
    },
    {
      prop: 'sj_hs',
      label: '实际总耗时',
      sortable: 'custom',
      width: 150,
    },
    {
      prop: 'bz_hs',
      label: '标准耗时',
      width: 150,
    },
    {
      prop: 'cz_hs',
      label: '差值',
    },
    {
      prop: 'status',
      label: '人员达标情况',
      width: 150,
    },
    {
      prop: 'explanation',
      label: '异常原因说明',
      width: 150,
    },
    {
      prop: 'type',
      label: '异常原因类型',
      width: 150,
    },
    {
      prop: 'origin',
      label: '异常原因来源',
      width: 150,
    },
    {
      prop: 'is_rational',
      label: '异常原因合理性',
      width: 150,
    },
  ],
  data: [],
  totalCount: 0,
  pageNo: 1,
  pageSize: 10,
  sort_order: 0,
};

export const inOverviewTableForm = {
  fieldList: [
    {
      label: '人员达标情况',
      value: 'status',
      type: 'select',
      list: 'db',
      event: 'status',
    },
    {
      label: '异常原因类型',
      value: 'type',
      type: 'select',
      list: 'type',
      event: 'type',
    },
    {
      label: '异常原因来源',
      value: 'origin',
      type: 'select',
      list: 'origin',
      event: 'origin',
    },
    {
      label: '异常原因合理性',
      value: 'rationality',
      type: 'select',
      list: 'rationality',
      event: 'rationality',
    },
  ],
  data: {
    status: 0,
    type: 0,
    origin: 0,
    rationality: 0,
  },
  listTypeInfo: {
    db: [
      {
        key: '全部',
        value: 0,
      },
      {
        key: '达标',
        value: 1,
      },
      {
        key: '未达标',
        value: 2,
      },
    ],
    type: [
      {
        key: '全部',
        value: 0,
      },
      {
        key: '作业技能不足',
        value: 1,
      },
      {
        key: '任务调度相关',
        value: 2,
      },
      {
        key: '假期',
        value: 3,
      },
      {
        key: '平台',
        value: 4,
      },
      {
        key: '培训/考试',
        value: 5,
      },
    ],
    origin: [
      {
        key: '全部',
        value: 0,
      },
      {
        key: '外包商',
        value: 1,
      },
      {
        key: '内部',
        value: 2,
      },
    ],
    rationality: [
      {
        key: '全部',
        value: 0,
      },
      {
        key: '合理',
        value: 1,
      },
      {
        key: '不合理',
        value: 2,
      },
    ],
  },
};

export const tableyxDetail = {
  column: [
    {
      prop: 'time',
      label: '日期',
      fixed: 'left',
    },
    {
      prop: 'name',
      label: '姓名',
      fixed: 'left',
    },
    {
      prop: 'outsourcer',
      label: '供应商',
      fixed: 'left',
    },
    {
      prop: 'production_line',
      label: '产线',
      fixed: 'left',
    },
    {
      prop: 'zy_zz_hs',
      label: '中业制作耗时(H)',
      width: 150,
    },
    {
      prop: 'zy_nj_hs',
      label: '中业内检耗时(H)',
      width: 150,
    },
    {
      prop: 'zy_ys_hs',
      label: '中业验收耗时(H)',
      width: 150,
    },
    {
      prop: 'zy_hs',
      label: '中业耗时(H)',
      width: 150,
    },
    {
      prop: 'ny_zz_hs',
      label: '内业作业耗时（H）',
      width: 150,
    },
    {
      prop: 'ny_nj_hs',
      label: '内业内检耗时（H）',
      width: 150,
    },
    {
      prop: 'ny_ys_hs',
      label: '内业验收耗时（H）',
      width: 150,
    },
    {
      prop: 'ny_hs',
      label: '内业耗时(H)',
      width: 150,
    },
    {
      prop: 'sj_hs',
      label: '人天总耗时(H)',
      fixed: 'right',
      width: 150,
    },
  ],
  data: [],
  totalCount: 0,
  pageNo: 1,
  pageSize: 10,
};

// 内部产线管理人员筛选框
export const checkStatusOptions = [
  {
    value: 0,
    label: '未审核',
  },
  {
    value: 1,
    label: '已审核',
  },
  {
    value: 2,
    label: '审核过期',
  },
  {
    value: 3,
    label: '全部',
  },
];

export const productLineCheckerTable = {
  column: [
    {
      type: 'selection',
      width: 55,
    },
    {
      prop: 'statis_day',
      label: '日期',
    },
    {
      prop: 'name',
      label: '姓名',
    },
    {
      prop: 'outsourcer',
      label: '供应商',
    },
    {
      prop: 'production_line',
      label: '产线',
    },
    {
      prop: 'zy_hs',
      label: '中业总耗时',
    },
    {
      prop: 'ny_hs',
      label: '内业总耗时',
    },
    {
      prop: 'sj_hs',
      label: '实际总耗时',
    },
    {
      prop: 'status',
      label: '人员达标情况',
    },
    {
      prop: 'explanation',
      label: '异常原因说明',
    },
    {
      prop: 'type',
      label: '异常原因类型',
      sortable: true,
    },
    {
      prop: 'origin',
      label: '异常原因来源',
      sortable: true,
    },
    {
      prop: 'is_checked',
      label: '状态',
      width: 80,
    },
  ],
  data: [],
  pageNo: 1,
  pageSize: 10,
  is_checked: 0,
};

export const supplierCheckTable = {
  column: [
    {
      type: 'selection',
      width: 55,
    },
    {
      prop: 'statis_day',
      label: '日期',
    },
    {
      prop: 'name',
      label: '姓名',
    },
    {
      prop: 'outsourcer',
      label: '供应商',
    },
    {
      prop: 'production_line',
      label: '产线',
    },
    {
      prop: 'zy_hs',
      label: '中业总耗时',
    },
    {
      prop: 'ny_hs',
      label: '内业总耗时',
    },
    {
      prop: 'sj_hs',
      label: '实际总耗时',
    },
    // {
    //   prop: 'explanation',
    //   label: '异常原因说明',
    // },
    // {
    //   prop: 'type_cn',
    //   label: '异常原因类型',
    // },
    // {
    //   prop: 'origin_cn',
    //   label: '异常原因来源',
    // },
  ],
  data: [],
  pageSize: 10,
  pageNo: 1,
  totalCount: 0,
};
